import React from "react";
import { Box, Wrapper } from "./style";
import { useQuery } from "react-query";
import { axiosInstance } from "api";
import Loading from "components/Loading";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { useNavigate } from "react-router";
const Com3 = () => {
  const { data: supportData, isLoading, isSuccess } = useQuery("supports", () => axiosInstance.get("/support"));
  const nav = useNavigate();
  const language = useSelector(selectLanguage);
  if (isLoading) return <Loading />;
  return (
    <>
      {isSuccess && (
        <Wrapper>
          {supportData.data.map((support) => (
            <Box onClick={() => nav(support.id + "/" + 0)} key={support.id}>
              <div>
                <img loading="lazy" src={support.img_path} alt="" />
                <span>{language === "en" ? support.title : support.titleKR}</span>
              </div>
            </Box>
          ))}
        </Wrapper>
      )}
    </>
  );
};

export default Com3;
